import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, CircleNotch, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

const inputCls =
  "w-full bg-[#0b0b0d] border border-white/10 text-white rounded-sm px-4 py-3 focus:outline-none focus:border-[#D97736] focus:ring-1 focus:ring-[#D97736] transition-colors placeholder:text-[#52525b]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#09090b] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A1A1AA] text-sm hover:text-[#D97736] transition-colors mb-8">
          <ArrowLeft size={16} /> Torna al sito
        </Link>
        <div className="bg-[#111113] border border-white/5 rounded-sm p-8 sm:p-10">
          <div className="w-14 h-14 rounded-sm bg-[#D97736]/10 flex items-center justify-center text-[#D97736] mb-6">
            <Lock size={26} />
          </div>
          <h1 className="font-display text-3xl font-bold">Area riservata</h1>
          <p className="text-[#A1A1AA] mt-2 text-sm">Accedi per gestire preventivi e prenotazioni.</p>

          <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-5">
            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="email@dominio.com" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Password</label>
              <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
            </div>
            <button data-testid="admin-login-submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-[#D97736] text-white px-8 py-4 rounded-sm font-semibold hover:bg-[#B85B22] transition-all disabled:opacity-60">
              {loading ? <CircleNotch size={20} className="animate-spin" /> : <Lock size={20} />}
              {loading ? "Accesso..." : "Accedi"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
